module.exports = __webpack_public_path__ + "static/img/qingdao3.0e780286.jpg";